import type { BanDich } from '../../types';
import type { viRpaLichSu } from './lich-su.vi';

export const enRpaLichSu: Pick<BanDich, keyof typeof viRpaLichSu> = {
  rpaLichSu: {
    moTa: 'OpenRPA runs stored in Native, synced from OpenCore and kept even after OpenCore removes them, with the error reports and Robot logs sent back.',
    tim: 'Search flow / ID / InstanceId / status / machine...',
    locTrangThai: 'Filter by status',
    moiTrangThai: 'All statuses',
    nguon: 'Stored in Native · {{tong}} runs · synced from OpenCore at {{luc}}',
    dangDongBo: 'syncing...',
    nguonLoi: 'Could not sync with OpenCore: showing {{tong}} runs stored in Native; the latest runs may be missing.',
    tongTrang: '{{tu}}–{{den}} of {{tong}} runs',
    rong: 'No runs yet',
    rongMoTa: 'OpenRPA runs appear here after a Robot runs a workflow and the server syncs from OpenCore.',
    rongLoc: 'No runs match the filters',
    cotThoiGian: 'Started',
    cotLuot: 'Flow / ID',
    cotTrangThai: 'Status',
    cotKetThuc: 'Finished',
    cotKiemLoi: 'Error check',
    cotLogRobot: 'Robot log',
    cotDuLieu: 'Execution data',
    xemLoi: 'View errors ({{so}})',
    xemLog: 'View log',
    xemDuLieu: 'View data',
    hopLoiTieuDe: 'Error report · {{ten}}',
    xemLogRobot: 'View Robot log',
    dongThoiGianTieuDe: 'Run timeline · {{ma}}',
    dongThoiGianRong: 'This run has no events yet.',
    instanceId: 'Instance ID (OpenCore)',
    trangThaiInstance: 'Instance status',
    may: 'Machine',
    trangThai: {
      completed: 'Succeeded',
      failed: 'Failed',
      timeout: 'Timed out',
      running: 'Running',
      idle: 'Idle',
      aborted: 'Cancelled',
    },
  },
  rpaBaoCao: {
    tieuDe: 'Error report from the Robot',
    chuaCo: 'The Robot has not sent an error report for this run. Reports upload in the background, so one may arrive after the run ends.',
    capNhat: 'Updated {{luc}} · upload {{lan}} · executionId {{ma}}',
    xemDongThoiGian: 'View timeline',
    khongCoLoi: 'The report has no errors.',
    cotLoi: 'Failed step',
    cotVideo: 'Video',
    cotAnh: 'Image',
    cotLog: 'Log',
    chiTietLoi: 'Error details',
    tepChung: 'Shared files',
    chuaCoTenBuoc: 'Unnamed step',
    chuaCoTep: 'None yet',
    xemAnh: 'View image',
    xemVideo: 'View video',
    xemLog: 'View log',
    hopTepTieuDe: '{{loai}} · {{ten}}',
    taiVe: 'Download',
    chuaCoVideo: 'No video yet. The Robot uploads the video after the run ends.',
    ghiChuLuuTru: 'Images and videos are stored in file storage, logs in the module database; files are deleted after the retention period set on the server.',
    maLoi: 'Error code: {{ma}}',
    lanThu: 'Attempt: {{lan}}',
    chuaThuocLoai: '{{ten}} · not mapped to an error type',
    nguyenNhan: 'Cause',
    heThongXuLy: 'Handling',
    nhomLoi: 'Error group',
    thuLai: 'Retry {{lan}} times, {{giay}} seconds apart',
    khongThuLai: 'No retry',
    hetLanBoQua: 'When retries run out, skip and report',
    hetLanDung: 'When retries run out, stop the run',
    chuaPhanLoai:
      'This error is not mapped to any error type in Error settings. Check the original message and exception details for the cause, then assign the exception to an error type.',
    thongBaoGoc: 'Original message from the Robot',
    khongCoThongBao: 'The Robot sent no error message.',
    chiTietException: 'Exception details',
  },
  rpaLogRobot: {
    tieuDe: 'Robot log · {{ten}}',
    chep: 'Copy',
    daChep: 'Copied the log.',
    khongChepDuoc: 'This page cannot copy to the clipboard. Use Download to get the log.',
    taiVe: 'Download',
    thieuTieuDe: 'Log missing.',
    chuaCo:
      'The Robot has not sent a log for this run. Logs are sent at the end of a run, so one may arrive later; if the run ended long ago, check the log upload step in the workflow.',
    khongCoInstance: 'This run has no InstanceId, so the Robot log cannot be linked to it.',
    workflow: 'Workflow',
    may: 'Machine',
    taiLenLuc: 'Uploaded at',
    dungLuong: 'Size',
    dungLuongGiaTri: '{{dong}} lines · {{kyTu}} characters',
    vungLog: 'Robot log content',
    ghiChu: 'The server masked tokens and passwords in the log. Old logs are deleted after the retention period.',
  },
  rpaDuLieu: {
    tieuDe: 'Execution data details',
    phuDe: '{{luong}} · Run ID: {{ma}}',
    chuaRoLuong: 'Unknown flow',
    quayLai: 'Back to History',
    khongCoInstance: 'This run has no InstanceId yet, so execution data cannot be linked to it.',
    soCao: 'Scraped data',
    soXuLy: 'Processed data',
    dong: 'data rows',
    tinhTrang: {
      match: 'Matched',
      missing: 'Missing data',
      extra: 'Extra data',
      empty: 'No execution data for this run yet.',
    },
    chiTiet: {
      match: 'processed all {{xuLy}}/{{cao}} scraped rows.',
      missing: '{{lech}} rows missing: scraped {{cao}}, processed only {{xuLy}}. Open the Compare tab to see which rows are missing.',
      extra: '{{lech}} extra rows: scraped {{cao}}, but processed {{xuLy}}. Open the Compare tab to see the extra rows.',
    },
    tab: {
      crawled: 'Scraped data',
      processed: 'Processed data',
      compare: 'Compare missing / extra',
      scrape: 'Scrape results',
    },
    tim: 'Search the data...',
    timTrong: 'Search {{ten}}',
    xuatJson: 'Export JSON',
    xuatCsv: 'Export CSV',
    daXuat: 'Exported {{so}} rows.',
    cotJson: 'Raw JSON',
    xemJson: 'View raw JSON of row {{dong}}',
    jsonTieuDe: 'Raw JSON · row {{dong}}',
    tongTrang: '{{tu}}–{{den}} of {{tong}} rows',
    rongLoc: 'No rows match the search',
    rong: {
      crawled: 'No scraped data for this run yet',
      processed: 'No processed data for this run yet',
    },
    rongMoTa: 'The Robot sends execution data while it runs; click Refresh to reload.',
    cotGhepNhan: 'Columns used to match scraped rows with processed rows',
    cotGhepMacDinh: 'All shared columns (default)',
    cotGhep: 'Match column',
    dangGhepTheo: 'Matching on: {{cot}}. Columns marked ★ in the table are match columns.',
    khongCoCotChung: 'The two tables share no columns to match on: every scraped row counts as missing.',
    cotBiBo:
      'Dropped from matching (timestamp columns or columns changed during processing): {{cot}}. Select them above to match on them anyway.',
    soKhop: 'Matched: {{so}}',
    soThieu: 'Missing: {{so}}',
    soDu: 'Extra: {{so}}',
    thieuTieuDe: 'Missing rows ({{so}}): scraped but not in the processed data',
    duTieuDe: 'Extra rows ({{so}}): in the processed data but not scraped',
    khongThieu: 'No missing rows.',
    khongDu: 'No extra rows.',
    lechBiCat: 'Showing the first {{hien}} of {{tong}} rows.',
    caoKhongCoMa: 'This run has no executionId yet, so scrape results cannot be looked up.',
    caoRong: 'No scrape results for this run yet',
    caoRongMoTa: 'Card-style scrape results appear only when the workflow sends them back.',
    caoLocNhan: 'Filter by tag',
    caoMoiNhan: 'All tags',
    caoViTri: 'Position',
    caoNhan: 'Tag',
    caoNoiDung: 'Content',
    caoNguon: 'Source page',
    caoLuc: 'Scraped at',
  },
  rpaSuCo: {
    moTa: 'Incidents in the last 30 days: errors reported by Robots using the configured error catalogue, failed instances on OpenCore and failed FOXAI runs.',
    tim: 'Search flow, project, machine, error message...',
    locKhoang: 'Time range',
    soNgay: '{{so}} days',
    locNguon: 'Filter by source',
    moiNguon: 'All sources',
    locProject: 'Filter by project',
    moiProject: 'All projects',
    locMucDo: 'Filter by severity',
    moiMucDo: 'All severities',
    locLoai: 'Filter by error type',
    moiLoai: 'All error types',
    boLoc: 'Clear filters',
    xuatCsv: 'Export CSV',
    daXuat: 'Exported {{so}} incidents.',
    daTai: '{{so}} incidents in 30 days (up to 500 rows per source). Robot-reported errors take their code and severity from the error catalogue; FOXAI classifies the rest by error type.',
    biCat: 'The results hit the limit and may not cover the whole period.',
    opencoreLoi: 'Could not read OpenCore: showing only Robot-reported errors and FOXAI runs.',
    rong: 'No incidents in the last 30 days',
    rongMoTa: 'Failed runs, cancelled runs and errors reported by Robots appear here.',
    rongKy: 'No incidents in the selected period.',
    rongLoc: 'No incidents match the filters',
    kpiTong: 'Incidents in loaded data',
    kpiLoi: 'Failed runs',
    kpiHuy: 'Cancelled',
    kpiMttr: 'MTTR',
    mttrChuaCo: 'No source data yet',
    theoNguonLoi: 'Error sources',
    trongDuLieu: 'In the loaded data',
    theoMucDo: 'By severity',
    theoMucDoGoiY: 'From the error catalogue; errors without a code are classified by FOXAI',
    suCoGiua: 'incidents',
    theoNgay: 'Incidents by day',
    theoNgayGoiY: 'Failed / cancelled runs by source',
    theoGio: 'Incidents by hour',
    gio: '{{gio}}:00–{{den}}:00',
    tong: 'Total',
    moTaCot: '{{cot}}: {{so}} incidents',
    soSuCoThe: '{{so}} incidents',
    theoProject: 'Incidents by project and source',
    moTaProject: '{{project}}: {{chiTiet}}',
    chuaCoProject: 'Unknown project',
    projectKhac: 'Other',
    chuaXacDinh: 'Unknown',
    danhSachLoi: 'Error list',
    tomTatLoai: 'Foreseen: {{luongTruoc}} types · Unexpected: {{batNgo}} types',
    cotLoi: 'Code / Error name',
    cotLoai: 'Error type',
    cotMucDo: 'Severity',
    cotSoLan: 'Count',
    cotSoLuong: 'Flows',
    cotGanNhat: 'Latest',
    dongThoiGian: 'Recent incident timeline',
    nhatKy: 'Detailed incident log',
    soSuCo: '{{so}} incidents',
    cotThoiDiem: 'Time',
    cotProject: 'Project',
    cotWorkflow: 'Flow',
    cotNguon: 'Error source',
    cotThongBao: 'Error message',
    cotTrangThai: 'Run status',
    khongCoThongBao: 'No error message yet',
    xemChiTietCua: 'View incident details of {{ten}}',
    chiTietTieuDe: 'Incident details',
    nguon: {
      foxai: 'FOXAI',
      opencore: 'OpenCore',
      robot: 'Robot',
    },
    ct: {
      thoiGian: 'Time',
      mucDo: 'Severity',
      project: 'Project',
      loai: 'Error type',
      maLoi: 'Code / Error name',
      nhomLoi: 'Error group',
      workflow: 'Workflow',
      may: 'Machine',
      buoc: 'Failed step',
      nguonLoi: 'Error source',
      id: 'ID',
      loiDayDu: 'Full error',
    },
    csv: {
      id: 'ID',
      thoiGian: 'Time',
      project: 'Project',
      workflow: 'Workflow',
      may: 'Machine',
      nguon: 'Source',
      maLoi: 'Code / Error name',
      loai: 'Error type',
      nguonLoi: 'Error source',
      mucDo: 'Severity',
      thongBao: 'Message',
      trangThai: 'Status',
    },
    loiNgan: {
      elementNotFound: 'UI element not found',
      nullReference: 'Variable or object has no data',
      nullValue: 'Missing input value',
      missingRead: 'Account lacks Read permission',
      unknownWorkflow: 'Robot cannot find the workflow',
      unknownQueue: 'Robot / queue not found',
      channelClosed: 'Lost connection to the Robot',
      invokeFailed: 'Robot invocation failed',
      licenseNotFound: 'License not found',
      databaseConnection: 'Cannot connect to the database',
      libraryLoad: 'Failed to load the OpenIAP library',
      userStopped: 'Stopped by user',
      accessDenied: 'Access denied',
      timeout: 'Timed out',
    },
  },
};
